<template>
  <div id="integrationsOverview" class="margin-subpages">
    <!-- System Integrations Section -->
    <div id="integrationStutus">
      <div class="sub-title">{{ $t("integrations.INTEGRATION_STATUS") }}</div>
      <div class="line-style mt-16" style="margin-bottom: 43px" />
      <div class="contriner-integration">
        <div class="card-integration">
          <img
            class="logo-integratioin"
            src="@/assets/images/integrations/icon_hris_sync@2x.png"
            alt="HRIS Sync"
          />
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">{{ $t("integrations.HRIS_Sync") }}</div>
              <div class="description">
                {{ $t("integrations.Sync_your_employee_data") }}
              </div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="hrisSync == 'conected'"
              @click="onClickTab('hrisSync')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickTab('hrisSync')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
        <div class="card-integration">
          <img
            class="logo-integratioin"
            src="@/assets/images/integrations/icon_API@2x.png"
            alt="icon API"
          />
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">{{ $t("integrations.Developer_API") }}</div>
              <div class="description">
                {{ $t("integrations.Activate_your_developer") }}
              </div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="api == 'conected'"
              @click="onClickTab('api')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickTab('api')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
        <div class="card-integration">
          <img
            class="logo-integratioin"
            src="@/assets/images/integrations/icon_SSO@2x.png"
            alt="icon SSO"
          />
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">{{ $t("integrations.SSO_Title") }}</div>
              <div class="description">{{ $t("integrations.SSO_Desc") }}</div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="selectedSso.enabled"
              @click="onClickTab('sso')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickTab('sso')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Connected Apps Section -->
    <div id="connectedApps" class="mt-32">
      <div class="sub-title">CONNECTED APPS</div>
      <div class="line-style mt-16" style="margin-bottom: 43px" />
      <div class="contriner-integration">
        <div class="card-integration">
          <div class="logo-integratioin slack-logo">
            <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.4 78.9c0 7.2-5.8 13-13 13s-13-5.8-13-13 5.8-13 13-13h13v13zm6.5 0c0-7.2 5.8-13 13-13s13 5.8 13 13v32.5c0 7.2-5.8 13-13 13s-13-5.8-13-13V78.9z" fill="#E01E5A"/>
              <path d="M45.9 26.4c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13v13h-13zm0 6.5c7.2 0 13 5.8 13 13s-5.8 13-13 13H13.4c-7.2 0-13-5.8-13-13s5.8-13 13-13h32.5z" fill="#36C5F0"/>
              <path d="M98.1 45.9c0-7.2 5.8-13 13-13s13 5.8 13 13-5.8 13-13 13h-13v-13zm-6.5 0c0 7.2-5.8 13-13 13s-13-5.8-13-13V13.4c0-7.2 5.8-13 13-13s13 5.8 13 13v32.5z" fill="#2EB67D"/>
              <path d="M78.6 98.1c7.2 0 13 5.8 13 13s-5.8 13-13 13-13-5.8-13-13v-13h13zm0-6.5c-7.2 0-13-5.8-13-13s5.8-13 13-13h32.5c7.2 0 13 5.8 13 13s-5.8 13-13 13H78.6z" fill="#ECB22E"/>
            </svg>
          </div>
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">Slack</div>
              <div class="description">
                Broadcast recognition, send report snippets, and nudge check-ins
              </div>
            </div>
          </div>
          <div class="flex-center">
            <el-button
              v-if="slackConnected"
              @click="onClickApp('slack')"
              class="conected"
              >{{ $t("integrations.Connected") }}</el-button
            >
            <el-button v-else @click="onClickApp('slack')" class="gray">{{
              $t("integrations.Setup")
            }}</el-button>
          </div>
        </div>
        <!-- Future app integrations can be added here -->
        <!-- <div class="card-integration">
          <div class="logo-integratioin teams-logo">...</div>
          <div class="flex-center menu">
            <div class="px-16">
              <div class="title">Microsoft Teams</div>
              <div class="description">...</div>
            </div>
          </div>
          <div class="flex-center">
            <el-button @click="onClickApp('teams')" class="gray">Setup</el-button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "overview",
  created() {
    // Fetch Slack configuration to show connection status
    this.$store.dispatch('slack/fetchConfiguration').catch(function() {});
  },
  computed: {
    selectedSso: function() {
      return this.$store.getters["integrations/selectedSso"];
    },
    slackConnected: function() {
      return this.$store.getters["slack/isConnected"];
    },
  },
  data: function() {
    return {
      hrisSync: "conected",
      api: "default",
      sso: "default",
    };
  },
  methods: {
    // For system integrations that have dedicated tabs
    onClickTab: function(tabName) {
      this.$emit("clicked", tabName);
    },
    // For app integrations that open in a dialog
    onClickApp: function(appId) {
      this.$emit("openAppIntegration", appId);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-integration {
  display: grid;
  grid-template-columns: 64px auto 113px;
  margin: 16px 0;
}
.logo-integratioin {
  border-radius: 6px;
  width: 64px;
  height: 64px;

  &.slack-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    padding: 0;

    svg {
      width: 48px;
      height: 48px;
    }
  }
}
.menu {
  .title {
    color: #4a4a4a;
    font-weight: 700;
    font-size: 18px;
    padding-bottom: 2px;
  }
  .description {
    color: #9d9d9d;
    font-size: 16px;
  }
}
</style>

<style lang="scss">
#integrationStutus .el-button,
#connectedApps .el-button {
  border-radius: 3px;
  height: 42px;
  width: 113px;
  margin: auto;
  font-weight: 700;
  transition: 0.2s;
}
#integrationStutus .el-button.gray,
#connectedApps .el-button.gray {
  background-color: #fff;
  border-color: #c9c9c9;
  color: #747474;
  &:hover {
    background-color: rgb(240, 240, 240);
  }
}
#integrationStutus .el-button.conected,
#connectedApps .el-button.conected {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #fff;
  &:hover {
    background-color: #2fb4c5;
  }
}
</style>
